<main role="main" class="page">
  @if (user | async; as profile) {
    <div class="card">
      @if (profile.eplUserId) {
        <h1>Access not set up yet</h1>
        <p class="lead">
          Your College Board account signed in successfully, but NPC Admin access has not been set up for your school yet.
        </p>
        <p class="note">
          After College Board staff authorize your account, you will receive an email letting you know you can sign in.
        </p>

        @if (profile.email) {
          <p class="signed-in">Signed in as {{ profile.email }}</p>
        }

        @if (requestError) {
          <p class="status error" role="alert">{{ requestError }}</p>
        }
        @if (requestMessage) {
          <p class="status success" role="status">{{ requestMessage }}</p>
        }

        <button
          mat-flat-button
          type="button"
          color="primary"
          class="action"
          (click)="requestAccess()"
          [disabled]="requestingAccess || !!requestMessage">
          {{ requestingAccess ? 'Sending request…' : 'Request access from College Board' }}
        </button>
      } @else {
        <h1>Awaiting access</h1>
        <p class="lead">
          Your account is pending authorization from College Board staff.
        </p>
        <p class="note">
          You will receive an email when your access has been approved and you can sign in to NPC Admin.
        </p>

        @if (profile.email) {
          <p class="signed-in">Signed in as {{ profile.email }}</p>
        }
      }
    </div>
  }
</main>
